import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable';
import { PROGRAM_DEFAULT } from '../../constants/state';
import { returnStateIfNoAction } from '../helpers';

const INIT_STATE = fromJS(PROGRAM_DEFAULT.hasUpdates)


function hasUpdatesReducer(state = INIT_STATE, action) {
    
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.HAS_UPDATES_SET_TRUE:
            return true
        case actionTypes.HAS_UPDATES_SET_FALSE:
            return false
        default:
            return state;
    }
}

export default hasUpdatesReducer